const PERMISSIONS = {
  CAN_VIEW_REQUESTS: 'view_requests',
  CAN_VIEW_USERS: 'view_users',
  CAN_EDIT_PRICES: 'edit_price',
};
export default PERMISSIONS;
